<template>
  <NodeViewWrapper class="my-4 overflow-hidden rounded-2xl border border-[#1c4848]/10 bg-white">
    <div class="relative" :class="dark ? 'backdrop-dark bg-[#143838] text-white' : 'bg-[#f7f2e4] text-[#1c4848]'">
      <img v-if="node.attrs.image" :src="node.attrs.image" alt="" class="pointer-events-none absolute inset-0 h-full w-full object-cover" contenteditable="false" draggable="false">
      <div class="pointer-events-none absolute inset-0" :class="dark ? 'bg-black/50' : 'bg-white/[0.78]'" contenteditable="false"></div>
      <NodeViewContent class="backdrop-body relative min-h-[160px] p-8 text-[16px] leading-relaxed" />
    </div>
    <div v-if="editor.isEditable" class="flex flex-wrap items-center gap-x-4 gap-y-1 px-3 py-2" contenteditable="false">
      <ImagePicker :context="editor.storage.writerContext" :has-image="Boolean(node.attrs.image)" compact @picked="updateAttributes({ image: $event })" />
      <OptionGroup label="Text colour" :value="node.attrs.tone" :options="TONE_OPTIONS" @pick="updateAttributes({ tone: $event })" />
    </div>
  </NodeViewWrapper>
</template>

<script setup>
import { computed } from 'vue';
import { NodeViewContent, NodeViewWrapper, nodeViewProps } from '@tiptap/vue-3';
import ImagePicker from '@/components/writer/views/ImagePicker.vue';
import OptionGroup from '@/components/writer/views/OptionGroup.vue';

const TONE_OPTIONS = [{ value: 'dark', label: 'White on dark' }, { value: 'light', label: 'Dark on light' }];

const props = defineProps(nodeViewProps);
const dark = computed(() => props.node.attrs.tone !== 'light');
</script>
